export enum FrontalTitleDict {
    'L' = 'Lift-up Door',
    'F' = 'Filler',
    'E' = 'Drawer Front',
    'D' = 'Drawer Front',
    'P' = 'Pull Out',
    'B' = 'Bi-fold Door',
    'T' = 'Tambour',
    'H' = 'Hinged Door',
    'O' = 'Open Frame'
}